import { NextDisplayView } from '../../login-authentication-screen/models/login-credentials.interface';

export interface CheckYourEmail {
  checkEmailMessage: string | undefined;
  checkEmailMessage_Login: string | undefined;
  headerSubTitle: string;
  headerTitle: string;
  nextDisplayView: NextDisplayView;
  viewName: string;
  logoUrl: string;
  altText: string;
  hasError: boolean;
  errorMessage: string;
  disabledActionButton: boolean;
  mfaCheckEmailMessage?: string;
  skipSqaContent: boolean;
}
